module.exports = __webpack_public_path__ + "static/media/2-2_UV_Coating.2ab01ae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-2_UV_Coating.jpg
// module id = 1718
// module chunks = 0